import PropTypes from 'prop-types'
import React from 'react'
import CustomerForm from '../Form'

export const NewCustomer = (props) => <CustomerForm {...props} />

NewCustomer.propTypes = {
  customer: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,

  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default NewCustomer



// WEBPACK FOOTER //
// ./src/components/Customers/New/NewCustomer.js